/**
 * theme.js — Dr. Prafullata Rajput Wellness Brand
 * Minimal, performance-first JavaScript. No jQuery.
 */

(function () {
  'use strict';


  /* =============================================
     2. FAQ ACCORDION
     Accessible: manages aria-expanded + hidden for each item
  ============================================= */
  document.querySelectorAll('[data-faq-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const answerId = trigger.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);

      // Collapse all siblings in the same list
      const parentList = trigger.closest('.faq-accordion__list');
      if (parentList) {
        parentList.querySelectorAll('[data-faq-trigger]').forEach(t => {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            const siblingId = t.getAttribute('aria-controls');
            const siblingAnswer = document.getElementById(siblingId);
            if (siblingAnswer) siblingAnswer.hidden = true;
          }
        });
      }

      trigger.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
    });
  });


  /* =============================================
     4. TESTIMONIAL SLIDER (Touch + Arrow support)
  ============================================= */
  document.querySelectorAll('[data-testimonial-slider]').forEach(slider => {
    const slides = slider.querySelectorAll('.testimonials__slide');
    const nextBtn = slider.querySelector('.testimonials__next');
    const prevBtn = slider.querySelector('.testimonials__prev');
    if (!slides.length) return;

    let current = 0;
    let startX = 0;

    const show = (idx) => {
      slides.forEach((s, i) => s.style.display = i === idx ? 'block' : 'none');
    };

    if (nextBtn) nextBtn.addEventListener('click', () => { current = (current + 1) % slides.length; show(current); });
    if (prevBtn) prevBtn.addEventListener('click', () => { current = (current - 1 + slides.length) % slides.length; show(current); });

    // Swipe support
    slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { current = (current + 1) % slides.length; }
        else { current = (current - 1 + slides.length) % slides.length; }
        show(current);
      }
    });

    show(0);
  });

  /* =============================================
     5. INTERSECTION OBSERVER — Scroll-triggered visibility
     Lightweight fallback if AOS CDN fails to load
  ============================================= */
  if (!window.AOS && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('[data-aos]').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      io.observe(el);
    });

    document.querySelectorAll('.is-visible').forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });
  }

})();
